import React from 'react'

const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: 'profile-card',
  name: 'Profile card',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/profile/route.js